/**
 * 树转列表
 * @export
 * @param {String} childrenKey
 * @param {Array} source
 * @return {Array}
 */
export function flattenTree(childrenKey, source) {
  const result = []

  dfs(source)

  return result

  function dfs(items) {
    if (!items) {
      return
    }

    for (const item of items) {
      result.push(item)
      if (item[childrenKey] && item[childrenKey].length > 0) {
        dfs(item[childrenKey])
      }
    }
  }
}

/**
 * 列表转树
 * @export
 * @param {String} idKey
 * @param {String} parentKey
 * @param {String} childrenKey
 * @param {Array} source
 * @return {Array}
 */
export function buildTree(idKey, parentKey, childrenKey, source) {
  const parentWrap = (nodes) => {
    const parentWrapper = new Map()

    nodes.forEach(node => {
      if (parentWrapper.has(node[parentKey])) {
        const children = parentWrapper.get(node[parentKey])
        if (children) {
          children.push(node)
        }
      } else {
        parentWrapper.set(node[parentKey], [node])
      }
    })

    return parentWrapper
  }

  const topLevelWrap = (nodes) => nodes.filter(
    (parent) => !nodes.find(node => node[idKey] === parent[parentKey])
  )

  const build = (topLevel, wrapper) => {
    return topLevel.map(node => {
      if (wrapper.has(node[idKey])) {
        const children = build(wrapper.get(node[idKey]), wrapper)
        return {
          ...node,
          [childrenKey]: children
        }
      } else {
        return node
      }
    })
  }

  const topLevelWrapper = topLevelWrap(source)
  const parentWrapper = parentWrap(source)

  return build(topLevelWrapper, parentWrapper)
}
